import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classnames from 'classnames';

import Icon, { GLYPHS } from '../../../../../common/icon';
import Modal from '../../../../../common/Modal';
import { t } from '../../../../../../modules/infra/i18n';

const STATUS_GLYPH = {
  waiting: GLYPHS.spinner,
  success: GLYPHS.check,
  error: GLYPHS.warning,
};

const BatchUpdateStatusModal = ({ batchUpdateStatus, batchUpdateInProgress }) => (
  <Modal close={noop} className="" title={t('barber:brand_barber.batch_update.modal_title')} display-if={batchUpdateInProgress}>
    <div className="u-mv">
      {batchUpdateStatus.map(shopUpdateStatus => (
        <div key={shopUpdateStatus.shopId} className="o-flexbox o-flexbox--justify-start c-modal__text">
          <Icon
            className={classnames('u-mr u-mt--', {
              'c-loader__animation': shopUpdateStatus.status === 'waiting',
              'u-font-color-warning': shopUpdateStatus.status === 'error',
            })}
            size="small"
            glyph={STATUS_GLYPH[shopUpdateStatus.status]}
          />
          <span >{shopUpdateStatus.shopName}</span>
        </div>
      ))}
    </div>
  </Modal>
);

BatchUpdateStatusModal.propTypes = {
  batchUpdateStatus: PropTypes.arrayOf(PropTypes.shape({
    status: PropTypes.oneOf(['waiting', 'success', 'error']).isRequired,
    shopId: PropTypes.string.isRequired,
    shopName: PropTypes.string.isRequired,
  })),
  batchUpdateInProgress: PropTypes.bool,
};

BatchUpdateStatusModal.defaultProps = {
  batchUpdateStatus: [],
  batchUpdateInProgress: false,
};

export default BatchUpdateStatusModal;
